import React from 'react';

type SortArrowsIconProps = {
  sortDirection?: 'asc' | 'desc' | null;
};

const SortArrowsIcon = ({
  sortDirection = null,
}: SortArrowsIconProps): JSX.Element => {
  return (
    <svg
      width="10"
      height="14"
      viewBox="0 0 10 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M5 1.75L8.53 5.75H1.47L5 1.75Z"
        fill="currentColor"
        opacity={sortDirection === 'desc' ? 0.35 : 1}
      />
      <path
        d="M5 12.25L1.47 8.25H8.53L5 12.25Z"
        fill="currentColor"
        opacity={sortDirection === 'asc' ? 0.35 : 1}
      />
    </svg>
  );
};

export default SortArrowsIcon;
